"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _useStyles = _interopRequireDefault(require("./useStyles"));

var _helpers = require("../Blinds/helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Dropdown = function Dropdown(_ref) {
  var item = _ref.item,
      maxDepth = _ref.maxDepth,
      maxColumns = _ref.maxColumns;
  var theme = (0, _styles.useTheme)();
  var nestedItemLength = item.items.length;
  var isMultiColumns = nestedItemLength - maxDepth > 0;
  var implicit = nestedItemLength - maxDepth * maxColumns;
  var rows = implicit === 0 ? maxDepth : maxDepth + Math.ceil(implicit / maxColumns);
  var cls = (0, _useStyles["default"])({
    isMultiColumns: isMultiColumns,
    columns: maxColumns,
    rows: rows
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: cls.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, (0, _helpers.getButtonProps)(item), {
    className: cls.link
  }), item.label), /*#__PURE__*/_react["default"].createElement(_core.List, {
    className: cls.nested
  }, item.items.map(function (x) {
    var _theme$palette, _theme$palette$primar;

    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      dense: true,
      key: x.label,
      style: {
        padding: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, (0, _helpers.getButtonProps)(x, {
      backgroundColor: theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      textDecoration: 'none'
    }), {
      className: cls.link,
      style: {
        textAlign: 'center'
      },
      fullWidth: true
    }), x.label));
  })));
};

Dropdown.defaultProps = {
  maxDepth: 3,
  maxColumns: 3
};
Dropdown.propTypes = {
  maxDepth: _propTypes["default"].number,
  maxColumns: _propTypes["default"].number,
  item: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string,
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      href: _propTypes["default"].string.isRequired
    }))
  }).isRequired
};
var _default = Dropdown;
exports["default"] = _default;